function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function extractNumber(str) {
  if (!str) return 0;
  const numberStr = str.replace(/[^0-9]/g, '');
  return parseInt(numberStr, 10);
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
  const { top, left, bottom, right } = el.getBoundingClientRect();
  const { innerHeight, innerWidth } = window;

  if (partiallyVisible) {
    return (
      (top >= 0 && top < innerHeight) ||
      (bottom > 0 && bottom <= innerHeight)
    ) &&
    (
      (left >= 0 && left < innerWidth) ||
      (right > 0 && right <= innerWidth)
    );
  } else {
    return top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
  }
};

document.querySelectorAll('[id^="Details-"] summary').forEach(summary => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if ( !summary.classList.contains('header__icon--menu') && !summary.classList.contains('menu-drawer__menu-item') && !summary.classList.contains('facets__summary') && !summary.classList.contains('mobile-facets__summary') ) {
    summary.addEventListener('click', event => {
      const currentDetails = event.currentTarget.closest('details');
      const accordionWrapper = event.currentTarget.closest('.accordion-wrapper');

      accordionWrapper.querySelectorAll('details[open]').forEach((details) => {
        if (details !== currentDetails) {
          gsap.to(details.querySelector('.accordion__content'), {
            height: 0,
            marginTop: 0,
            marginBottom: 0,
            duration: 0.5,
            ease: 'power1.inOut',
            onComplete: myFunction
          });

          function myFunction() {
            details.removeAttribute('open');
            details.querySelector('summary').setAttribute('aria-expanded', false);
          }
        }
      });

      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));

      // Add GSAP animation to open current details
      gsap.fromTo(
        currentDetails.querySelector('.accordion__content'),
        {
          height: 0,
          marginTop: 0,
          marginBottom: 0,
        },
        {
          height: 'auto',
          marginTop: '0.5rem',
          marginBottom: '1.5rem',
          duration: 0.5,
          ease: 'power1.inOut',
        }
      );
    });
  } else {
    summary.addEventListener('click', (event) => {
      const currentDetails = event.currentTarget.closest('details');
      const facetsWrapper = event.currentTarget.closest('#FacetsWrapperDesktop');
      const isOpen = !event.currentTarget.closest('details').hasAttribute('open');

      if (facetsWrapper) {
        facetsWrapper.querySelectorAll('details[open]').forEach((details) => {
          if (details !== currentDetails) {
            details.removeAttribute('open');
          }
        })
      }
      event.currentTarget.setAttribute('aria-expanded', isOpen);
    });

    // summary.addEventListener('click', (event) => {
    //   const isOpen = !event.currentTarget.closest('details').hasAttribute('open');
    //   event.currentTarget.setAttribute('aria-expanded', isOpen);
    //   event.currentTarget.closest('details').setAttribute('open', isOpen);
    // });
  }

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// Add event listener to close details when clicking outside of dropdown
document.body.addEventListener('click', (event) => {
  const facetsSummary = document.querySelector('.facets__summary');
  const mobileFacetsSummary = document.querySelector('.mobile-facets__summary');

  if (facetsSummary && !facetsSummary.contains(event.target) || (mobileFacetsSummary && !mobileFacetsSummary.contains(event.target))) {
    const openDetails = document.querySelectorAll('details[open]');

    openDetails.forEach((details) => {
      if (!details.contains(event.target)) {
        details.removeAttribute('open');
      }
    });
  }
});


// Get the height of the sticky header
const headerHeight = document.querySelector('sticky-header').offsetHeight;
// Get all anchor tags
const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href*="popup"]):not([href*="recover"]):not([href*="login"]):not(.tab-link):not(.claim--offer)');
// Add event listener to each anchor tag
anchorLinks.forEach(function(anchorLink) {
  anchorLink.addEventListener('click', function(event) {
    // Prevent default behavior of anchor tag
    event.preventDefault();

    // Get the target element's name attribute
    const targetName = anchorLink.getAttribute('href').substr(1);

    // Find the target element by name
    const targetElement = document.querySelector('[name="' + targetName + '"], [id="' + targetName + '"]');
    //alert('targetElement: '+targetElement);
    // Scroll to the target element smoothly, accounting for the header height
    if (targetElement) {
      const targetOffset = targetElement.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: targetOffset - headerHeight,
        behavior: 'smooth'
      });
    }
  });
});


const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button:not([id^="Deferred-Poster-"])');

    if (!button) return;

    button.addEventListener('click', () => {
      if (button.classList.contains('pause-button')) {
        window.pauseAllMedia();
        button.classList.add('play-button');
        button.classList.remove('pause-button');
      } else if (button.classList.contains('play-button')) {
        // Play the media
        const media = button.closest('modal-opener').querySelector('video, iframe');
        if (media) {
          if (media.tagName === 'VIDEO') {
            media.play();
          } else if (media.tagName === 'IFRAME') {
            // For YouTube iframes
            media.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
            // For Vimeo iframes
            media.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
        button.classList.add('pause-button');
        button.classList.remove('play-button');
      } else {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      }
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderNavigator = this.querySelectorAll('.slider-navigator');
    this.sliderActiveItem = parseInt(1);

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.sliderNavigator.forEach((dot) => dot.addEventListener('click', this.onDotClick.bind(this)));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    // Update dot state based on current page
    const currentDot = this.sliderNavigator[this.currentPage - 1];
    if (currentDot && currentDot.dataset.step !== undefined && currentDot.dataset.step !== null) {
      this.sliderActiveItem = parseInt(currentDot.dataset.step);
    }
    this.setDotState(currentDot);
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  onDotClick(event) {
    event.preventDefault();

    const step = parseInt(event.currentTarget.dataset.step) || 1;
    const newPosition =
      step > this.sliderActiveItem
        ? this.slider.scrollLeft + (step - this.sliderActiveItem) * this.sliderItemOffset
        : this.slider.scrollLeft - (this.sliderActiveItem - step) * this.sliderItemOffset;

    this.slideScrollPosition = newPosition;
    this.setSlidePosition(this.slideScrollPosition);
    this.sliderActiveItem = parseInt(event.currentTarget.dataset.step);
  }

  setDotState(element) {
    if (element) {
      this.sliderNavigator.forEach(dot => dot.classList.remove('slider-navigator--active'));
      element.classList.add('slider-navigator--active');

      const dotWidth = element.offsetWidth;
      const computedStyles = window.getComputedStyle(element);
      const marginLeft = parseInt(computedStyles.marginLeft);
      const marginRight = parseInt(computedStyles.marginRight);
      const marginWidth = marginLeft + marginRight;
      const containerWidth = element.parentNode.offsetWidth;

      const sliderArray = Array.from(this.sliderNavigator);
      const selectedIndex = sliderArray.indexOf(element);

      if (selectedIndex >= 0) {
        let totalWidth = (dotWidth + marginWidth) * selectedIndex;

        const activeDotCenter = totalWidth + (dotWidth + marginWidth) / 2;
        const containerCenter = containerWidth / 2;
        let scrollPosition = activeDotCenter - containerCenter;

        const maxScroll = (dotWidth + marginWidth) * sliderArray.length - containerWidth;
        scrollPosition = Math.max(0, Math.min(scrollPosition, maxScroll));

        element.parentNode.style.transform = `translateX(-${scrollPosition}px)`;
      }
    }
  }


  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItemsToShow.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    const supportsInert = 'inert' in HTMLElement.prototype;

    this.sliderItemsToShow.forEach((item, index) => {
      const focusableElements = getFocusableElements(item);

      if (index === this.currentPage - 1) {
        item.removeAttribute('inert');
        item.removeAttribute('aria-hidden');
        item.removeAttribute('tabindex');

        focusableElements.forEach((element) => {
          element.removeAttribute('tabindex');
        });
      } else {
        if (supportsInert) {
          item.setAttribute('inert', '');
        } else {
          item.setAttribute('aria-hidden', true);
          focusableElements.forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
        }
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    this.lastClickedFieldset = null;
    this.isFbt = false;

    // Add click listeners to all radio inputs
    this.querySelectorAll('fieldset input[type="radio"]').forEach(input => {
      input.addEventListener('click', (event) => {
        this.lastClickedFieldset = event.target.closest('fieldset');
      });
    });
  }


  onVariantChange(e) {
    e.stopPropagation();

    this.hybridVariant = this.dataset.hybridVariant;
    this.isHybridVariant = this.hybridVariant && this.hybridVariant.toLowerCase?.() === 'true';
    this.hybridProduct = this.dataset.hybridProduct;
    this.isHybridProduct = this.hybridProduct && this.hybridProduct.toLowerCase?.() === 'true';
    this.isFbt = this.dataset.fbt && this.dataset.fbt.toLowerCase?.() === 'true';

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateBundleVariantSelection();

    if (!this.currentVariant) {
      // this.setUnavailable();
      if (this.isHybridVariant && !this.isHybridProduct) {
        this.setHybridVariant();
        this.updateVariantInput();
      }

      if (this.isHybridProduct) {
        this.getHybridProductData();
        this.setHybridProduct();
        this.updateVariantInput();
      }
    } else {
      if (!this.isFbt) {
        this.updateMedia();
      } else {
        this.updateMediaFbt();
      }
      if (!this.isFbt) this.updateURL();
      this.updateVariantInput();
      if (!this.isFbt)  this.renderProductInfo();
      // this.updateDelayNotice();
      if (!this.isFbt) this.updateShareUrl();
      this.updateFieldsetValue();
      this.updateBundleBaseProductPrice();

      if (!this.isHybridVariant && !this.isHybridVariant && !this.isFbt)
        this.setVariantOOSForm();

      if (!this.isHybridProduct && this.currentVariant.available) {
        if (!this.isFbt) this.updateRecommendProduct();
      }

      if (this.isHybridVariant && !this.isHybridProduct) {
        this.updateVariantPrice();
      } else if (this.isFbt) {
        this.updatePriceFbtPrice();
      } else {
        this.updatePrice();
      }

      this.updateDescription();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value.trim());
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      const comparison = variant.options.map((option, index) => {
        return this.options[index] === option;
      });

      return this.options.includes('') ? comparison.includes(true) : comparison.every(Boolean);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    console.log('[Gallery SKU match] variant:', this.currentVariant.sku);
    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMediaForVariant(this.currentVariant.sku, this.currentVariant.featured_image.product_id, this.currentVariant.featured_media.id)
    });

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
  }

  updateMediaFbt() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const gbtGallary = document.querySelector(`#FBTGallary-${this.currentVariant.featured_image.product_id}`);
    if (!gbtGallary) return;

    const images = gbtGallary.querySelectorAll('img');
    images.forEach((image) => {
      if (image.dataset.variantId == this.currentVariant.id) {
        image.classList.remove('hidden');
      } else {
        image.classList.add('hidden');
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateFieldsetValue() {
    if (!this.currentVariant) return;


    // Find any variant inputs with group data that match the current variant
    const groupedInputs = this.querySelectorAll('input[data-variant-group]');
    let matchingGroupedInput = null;

    // Check if any grouped input matches the current variant selection
    groupedInputs.forEach(input => {
      // Try matching by checked state
      if (input.checked && input.dataset.variantGroup) {
        matchingGroupedInput = input;
      }

      // Also try matching by current variant option value
      if (input.dataset.variantGroup &&
          this.currentVariant &&
          (this.currentVariant.option1 === input.value ||
           this.currentVariant.option2 === input.value ||
           this.currentVariant.option3 === input.value)) {
        matchingGroupedInput = input;
      }
    });

     if (matchingGroupedInput && matchingGroupedInput.dataset.variantGroup) {
       const variantGroup = matchingGroupedInput.dataset.variantGroup;

       // First, reset ALL group text elements to empty
       const allGroupTextElements = document.querySelectorAll('[data-group-text]');
       allGroupTextElements.forEach(element => {
         element.textContent = '';
       });

       // Then update only the selected group's text
       const groupTextElement = document.querySelector(`[data-group-text="${variantGroup}"]`);
       if (groupTextElement) {
         groupTextElement.textContent = ` - ${matchingGroupedInput.value}`;
       }

       return; // Exit early so we don't update other elements
     } else {

       // Check if this is a default (non-grouped) variant selection
       const allCheckedInputs = this.querySelectorAll('input[type="radio"]:checked');
       const hasNonGroupedSelection = Array.from(allCheckedInputs).some(input =>
         !input.dataset.variantGroup &&
         this.currentVariant &&
         (this.currentVariant.option1 === input.value ||
          this.currentVariant.option2 === input.value ||
          this.currentVariant.option3 === input.value)
       );

       if (hasNonGroupedSelection) {
         // Reset all group text elements to empty (except default)
         const allGroupTextElements = document.querySelectorAll('[data-group-text]');
         allGroupTextElements.forEach(element => {
           if (element.dataset.groupText !== 'default') {
             element.textContent = '';
           }
         });

         // Update default group text
         const defaultGroupElement = document.querySelector('[data-group-text="default"]');
         if (defaultGroupElement && this.currentVariant) {
           const optionValue = this.currentVariant.option2 || this.currentVariant.option1;
           defaultGroupElement.textContent = `- ${optionValue}`;
         }

         return; // Exit early
       }
     }

    // Handle regular (non-grouped) selected-swatch-text elements
    const fieldsetLabel = this.querySelectorAll('.selected-swatch-text:not([data-group-text])');

    if (fieldsetLabel) {
      fieldsetLabel.forEach((label, i) => {
        label.textContent = fieldsetLabel.length > 1 ? this.currentVariant.options[i] : this.currentVariant.option2 || this.currentVariant.option1;
      });
    }
  }

  updateBundleBaseProductPrice() {
    const bundleBaseProductPrice = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (!bundleBaseProductPrice) return;
    bundleBaseProductPrice.dataset.productPrice = (this.currentVariant.price/100).toFixed(2);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    let productForms;
    if (this.isFbt) {
      productForms = document.querySelectorAll(
        `#product-form-fbt-${this.dataset.blockId}${this.currentVariant.featured_image.product_id}`
      );
    } else {
      productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-fbt-${this.dataset.section}`
      );
    }
    let hybridFilteredData

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');

      if (this.isHybridVariant && !this.isHybridProduct) {
        hybridFilteredData = this.variantData.filter(item => {
          const hybridOptions = this.options[0].split(' + ').map(option => option.trim());
          const isHybridVariant = hybridOptions.some(option => item.option1.includes(option)) && (item.option2 === this.options[1] || !item.option2);
          const isSmallSize = item.option2 === this.options[1] || !item.option2;
          return isHybridVariant && isSmallSize;
        });
      } else if (this.isHybridProduct) {
        if (this.options[0].includes('+')) {
          hybridFilteredData = [this.variantData[0], this.hybridData]
        } else {
          hybridFilteredData = this.currentVariant ? this.currentVariant : [this.hybridData];
        }
      }

      let variantId;
      if (this.currentVariant) {
          variantId = this.currentVariant.id
      } else {
        variantId = hybridFilteredData.map(item => item.id).join(",")
      }

      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );

    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateBundleVariantSelection() {
    if (this.getVariantData()[0]?.featured_image?.product_id === 8132668948677) {
      const fieldsets = this.querySelectorAll('fieldset');

      if (!this.lastClickedFieldset) return;

      const checkedValues = Array.from(this.lastClickedFieldset.querySelectorAll('input[type="radio"]:checked'))
        .map(input => input.value);

      // Get the other fieldset to update
      const otherFieldset = this.lastClickedFieldset === fieldsets[0] ? fieldsets[1] : fieldsets[0];

      // Update the radio buttons in the otherFieldset
      otherFieldset.querySelectorAll('input[type="radio"]').forEach(input => {
        if (checkedValues.includes(input.value) && !input.disabled && !input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value')) || this.querySelector(':checked').dataset?.hybridVariantIds) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateRecommendProduct() {
    const variantId = this.currentVariant.id
    if(document.querySelector('.product-recommend')){
    const recommendCount = parseInt(document.querySelector('.product-recommend').dataset.recommendCount);
    if ( recommendCount > 0 ) {
      document.querySelectorAll('.this-product select').forEach(function(select) {
        select.value = variantId;
        select.dispatchEvent(new Event('change'));
      });
    }
  }
  }

  updateDescription() {
    if (this.currentVariant.featured_image.product_id === 7403791810757) {
      const yardonly = document.querySelectorAll('.yardonly');
      const bassinetonly = document.querySelectorAll('.bassinetonly');

      if (this.currentVariant.id === 42120754102469) {
        bassinetonly.forEach(function(bassinet) {
          bassinet.style.display = 'block';
        });
        yardonly.forEach(function(yard) {
          yard.style.display = 'none';
        })
      } else {
        yardonly.forEach(function(bassinet) {
          bassinet.style.display = 'block';
        });
        bassinetonly.forEach(function(yard) {
          yard.style.display = 'none';
        })
      }
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // Cancel any section render still in flight. The stale-response guard below
    // stops a late reply from painting the wrong variant, but it does not free
    // the connection: a burst of swatch clicks otherwise leaves one live request
    // each, and once the browser hits its per-host limit the click the shopper
    // actually cares about queues behind the abandoned ones. That wait is what
    // reads as the picker sticking.
    if (this.sectionRenderAbort) this.sectionRenderAbort.abort();
    this.sectionRenderAbort = new AbortController();

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`,
      { signal: this.sectionRenderAbort.signal }
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        // const destination = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
        // const source = html.getElementById(
        //   `ProductSubmitButton-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        const oosFormSource = html.getElementById(
          `OOSForm-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );;
        const oosFormDestination = document.getElementById(`OOSForm-${this.dataset.section}`);

        const delayNoticeSource = html.getElementById(
          `DelayNotice-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const delayNoticeDestination = document.getElementById(`DelayNotice-${this.dataset.section}`);

        const productBundleSource = html.getElementById(
          `ProductBundle-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const productBundleDestination = document.getElementById(`ProductBundle-${this.dataset.section}`);

        const priceButton = `price-button-${this.dataset.section}`;
        const destinationPriceButton = document.getElementById(priceButton);
        const sourcePriceButton = html.getElementById(priceButton);
        if (destinationPriceButton && sourcePriceButton) destinationPriceButton.innerHTML = sourcePriceButton.innerHTML;

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        // if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        if (oosFormSource && oosFormDestination) {
          oosFormDestination.innerHTML = oosFormSource.innerHTML;
          oosFormDestination.classList.toggle('oos-notices--hidden', oosFormSource.classList.contains('oos-notices--hidden'));
        }

        // if (productBundleSource && productBundleDestination) {
        //   productBundleDestination.innerHTML = productBundleSource.innerHTML;
        //   const script = productBundleDestination.querySelectorAll('script');
        //   script.forEach((script) => {
        //     const scriptContent = script.textContent || script.innerText;
        //     if (scriptContent.trim()) {
        //       try {
        //         eval(scriptContent);

        //         // Extract the onAjaxUpdate method and execute it
        //         const onAjaxUpdateFn = new Function(`
        //           ${scriptContent}
        //           return onAjaxUpdate;
        //         `)();

        //         if (typeof onAjaxUpdateFn === 'function') {
        //           onAjaxUpdateFn();
        //         } else {
        //           console.warn('onAjaxUpdate function not found in script content.');
        //         }
        //       } catch (error) {
        //         console.error('Error executing script:', error);
        //       }
        //     }
        //   });
        // }

        if (delayNoticeSource && delayNoticeDestination) {
          delayNoticeDestination.innerHTML = delayNoticeSource.innerHTML;
          delayNoticeDestination.classList.toggle('oos-notices--hidden', delayNoticeSource.classList.contains('oos-notices--hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((error) => {
        // Superseded by a newer selection — expected, not a failure.
        if (error.name === 'AbortError') return;
        throw error;
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setVariantOOSForm() {
    if ( !this.currentVariant ) return;

    const button = document.querySelector('.product-form');
    const oosForm = document.getElementById(`OOSForm-${this.dataset.section}`);
    const delayNotice = document.getElementById(`DelayNotice-${this.dataset.section}`);
    const registryButton = document.getElementById(`Registry-${this.dataset.section}`);

    if ( this.currentVariant.available ) {
      button.classList.remove('hidden');
      delayNotice.classList.remove('hidden');
      registryButton.classList.remove('hidden');
      oosForm.classList.add('oos-notices--hidden');
    } else {
      // button.classList.add('hidden');
      delayNotice.classList.add('hidden');
      registryButton.classList.add('hidden');
      oosForm.classList.remove('oos-notices--hidden');

      oosForm.setAttribute('sku', this.currentVariant.sku);
      // if (oosForm) {
      //   oosForm.attachEventListeners();
      // }
    }
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][id="variantsJson"]').textContent);
    return this.variantData;
  }

  getHybridProductData() {
    this.hybridData = this.hybridData || JSON.parse(this.querySelector('[type="application/json"][id="hybridProductJson"]').textContent);
    return this.hybridData;
  }

  updateVariantPrice() {
    if (!this.currentVariant) return;

    let bundleComparePrice = this.currentVariant.compare_at_price || 0;
    let bundlePrice = 0;

    const sizeFieldset = this.querySelector(`#Size-${this.dataset.section}`);
    let sizeItems;
    if (sizeFieldset)
      sizeItems = sizeFieldset.querySelectorAll('.swatch-item');

    const filteredData = this.variantData.filter(obj => obj.option1 === this.currentVariant.option1);
    if (sizeItems)
      sizeItems.forEach((sizeItem, i) => {
        const sizePrice = sizeItem.querySelector('label > .swatch-price');
        sizePrice.textContent = `$ ${filteredData[i].price / 100}`;
      });

    const bundleData = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (bundleData) {
      bundleData.querySelectorAll('input').forEach((checkbox, i) => {
        const inputComparePrice = checkbox.dataset.comparePrice;
        const inputPrice = checkbox.dataset.price;
        if (checkbox.name === 'bundle' && checkbox.checked) {
          const selectedVariant = checkbox.parentElement.nextElementSibling.querySelector('input[type="radio"]:checked');
          bundleComparePrice = extractNumber(selectedVariant.dataset.comparePrice)
          bundlePrice = extractNumber(selectedVariant.dataset.price)
        } else if (checkbox.name === 'bundle-product-single' && checkbox.checked) {
          bundleComparePrice = extractNumber(inputComparePrice)
          bundlePrice = extractNumber(inputPrice)
        }
      });
    }

    const comparePriceElm = document.querySelector('#compare-price-button');
    if (comparePriceElm) {
      if (bundleComparePrice !== 0 || this.currentVariant.compare_at_price !== null) {
        comparePriceElm.classList.remove('hidden')
      } else if (bundleComparePrice === 0 && this.currentVariant.compare_at_price == null) {
        comparePriceElm.classList.add('hidden')
      }

      // const comparePrice = this.currentVariant.compare_at_price || this.currentVariant.price;
      const totalComparePrice = bundleComparePrice !== 0 ? bundleComparePrice : 0;

      comparePriceElm.textContent = `$ ${(totalComparePrice / 100).toFixed(2)}`
    }

    const totalPrice = this.currentVariant.price + (bundlePrice !== 0 ? bundlePrice : 0);
    const priceString = `$ ${(totalPrice / 100).toFixed(2)}`;

    const productSubmitButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    productSubmitButton.querySelector('#price-button').textContent = priceString;
  }

  updatePrice() {
    if (!this.currentVariant) return;

    let bundleComparePrice = 0;
    let bundlePrice = 0;
    const bundleData = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (bundleData) {
      bundleData.querySelectorAll('input').forEach((checkbox, i) => {
        const inputComparePrice = checkbox.dataset.comparePrice;
        const inputPrice = checkbox.dataset.price;
        if (checkbox.name === 'bundle' && checkbox.checked) {
          const selectedVariant = checkbox.parentElement.nextElementSibling.querySelector('input[type="radio"]:checked');
          bundleComparePrice = extractNumber(selectedVariant.dataset.comparePrice)
          bundlePrice = extractNumber(selectedVariant.dataset.price)
        } else if (checkbox.name === 'bundle-product-single' && checkbox.checked) {
          bundleComparePrice = extractNumber(inputComparePrice)
          bundlePrice = extractNumber(inputPrice)
        }
      });
    }

    const comparePriceElm = document.querySelector('#compare-price-button');
    if (comparePriceElm) {
      if (bundleComparePrice !== 0 || this.currentVariant.compare_at_price !== null) {
        comparePriceElm.classList.remove('hidden')
      } else if (bundleComparePrice === 0 && this.currentVariant.compare_at_price == null) {
        comparePriceElm.classList.add('hidden')
      }

      const comparePrice = this.currentVariant.compare_at_price || this.currentVariant.price;
      const totalComparePrice = comparePrice + (bundleComparePrice !== 0 ? bundleComparePrice : 0)
      comparePriceElm.textContent = `$ ${(totalComparePrice / 100).toFixed(2)}`
    };

    const totalPrice = this.currentVariant.price + (bundlePrice !== 0 ? bundlePrice : 0);
    const priceString = `$ ${(totalPrice / 100).toFixed(2)}`;

    const productSubmitButton = document.getElementById(`${this.isFbt ? 'FBT' : ''}ProductSubmitButton-${this.dataset.section}`);
    productSubmitButton.querySelector('#price-button').textContent = priceString;
  }

  updatePriceFbtPrice() {
    if (!this.currentVariant) return;

    let bundleComparePrice = 0;
    let bundlePrice = 0;
    const bundleData = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (bundleData) {
      bundleData.querySelectorAll('input').forEach((checkbox, i) => {
        const inputComparePrice = checkbox.dataset.comparePrice;
        const inputPrice = checkbox.dataset.price;
        if (checkbox.name === 'bundle' && checkbox.checked) {
          const selectedVariant = checkbox.parentElement.nextElementSibling.querySelector('input[type="radio"]:checked');
          bundleComparePrice = extractNumber(selectedVariant.dataset.comparePrice)
          bundlePrice = extractNumber(selectedVariant.dataset.price)
        } else if (checkbox.name === 'bundle-product-single' && checkbox.checked) {
          bundleComparePrice = extractNumber(inputComparePrice)
          bundlePrice = extractNumber(inputPrice)
        }
      });
    }

    const comparePriceElm = document.querySelector('#compare-price-button');
    if (comparePriceElm) {
      if (bundleComparePrice !== 0 || this.currentVariant.compare_at_price !== null) {
        comparePriceElm.classList.remove('hidden')
      } else if (bundleComparePrice === 0 && this.currentVariant.compare_at_price == null) {
        comparePriceElm.classList.add('hidden')
      }

      const comparePrice = this.currentVariant.compare_at_price || this.currentVariant.price;
      const totalComparePrice = comparePrice + (bundleComparePrice !== 0 ? bundleComparePrice : 0)
      comparePriceElm.textContent = `$ ${(totalComparePrice / 100).toFixed(2)}`
    };

    const totalPrice = this.currentVariant.price + (bundlePrice !== 0 ? bundlePrice : 0);
    const priceString = `$ ${(totalPrice / 100).toFixed(2)}`;

    const productSubmitButton = document.getElementById(`FBTProductSubmitButton-${this.dataset.section}-${this.currentVariant.featured_image.product_id}`);
    productSubmitButton.querySelector('#fbt-price-button').textContent = priceString;

    const fbtPriceWrapper = document.getElementById(`fbt-price-wrapper-${this.currentVariant.featured_image.product_id}`);
    fbtPriceWrapper.querySelector('.price-item--regular').textContent = priceString;
  }

  setHybridVariant() {
    const option2Map = new Map();
    const matchedOption2 = new Set();
    const matchedVariants = [];
    let bundlePrice = 0;

    this.variantData.forEach(variant => {
      if (option2Map.has(variant.option2 ? variant.option2 : variant.option1)) {
        option2Map.get(variant.option2 ? variant.option2 : variant.option1).push(variant);
      } else {
        option2Map.set(variant.option2 ? variant.option2 : variant.option1, [variant]);
      }
    });

    option2Map.forEach((variants, option2) => {
      if (variants.length > 1 && !matchedOption2.has(option2)) {
        for (let i = 0; i < variants.length - 1; i++) {
          for (let j = i + 1; j < variants.length; j++) {
            const variant1 = variants[i];
            const variant2 = variants[j];
            const totalPrice = variant1.price + variant2.price;
            matchedVariants.push({
              variant1,
              variant2,
              totalPrice
            });
            matchedOption2.add(option2);
          }
        }
      } else if (variants.length === 1 && !matchedOption2.has(option2)) {
        const variant1 = variants[0];
        let variant2 = null;

        for (const [otherOption, otherVariants] of option2Map.entries()) {
          if (otherOption !== option2 && otherVariants.length > 0) {
            variant2 = otherVariants[0];
            break;
          }
        }

        if (variant2) {
          const totalPrice = variant1.price + variant2.price;

          // Check if the pair already exists
          const exists = matchedVariants.some(v =>
            (v.variant1 === variant1 && v.variant2 === variant2) ||
            (v.variant1 === variant2 && v.variant2 === variant1)
          );

          if (!exists) {
            matchedVariants.push({
              variant1,
              variant2,
              totalPrice
            });
            matchedOption2.add(option2);
            matchedOption2.add(variant2.option2);
          }
        }
      }
    });

    const sizeFieldset = this.querySelector(`#Size-${this.dataset.section}`);
    let sizeItems;
    if (sizeFieldset) {
      sizeItems = sizeFieldset.querySelectorAll('.swatch-item');
    }

    if (sizeItems) {
      sizeItems.forEach((sizeItem, i) => {
        const sizePrice = sizeItem.querySelector('label > .swatch-price');
        sizePrice.textContent = `$ ${matchedVariants[i].totalPrice / 100}`;
      });
    }

    const matchedVariantPrice = matchedVariants.find(item =>
      item.variant1.option2 === this.options[1] || this.options[0].includes(item.variant1.option1)
    );

    // Check if either hybrid variant is unavailable
    const isHybridUnavailable = matchedVariantPrice &&
      (!matchedVariantPrice.variant1.available || !matchedVariantPrice.variant2.available);

    if (isHybridUnavailable) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    const bundleData = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (bundleData) {
      bundleData.querySelectorAll('input').forEach((checkbox, i) => {
        const inputPrice = checkbox.dataset.price;
        if (checkbox.name === 'bundle' && checkbox.checked) {
          bundlePrice = extractNumber(inputPrice)
        } else if (checkbox.name === 'bundle-product-single' && checkbox.checked) {
          bundlePrice = extractNumber(inputPrice)
        }
      });
    }

    const totalPrice = matchedVariantPrice.totalPrice + (bundlePrice !== 0 ? bundlePrice : 0);
    const priceString = `$ ${totalPrice / 100}`;

    const productSubmitButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    productSubmitButton.querySelector('#price-button').textContent = priceString;

    // Scroll gallery to the accessory variant's (variant2) image, matched by its SKU in the alt text
    if (matchedVariantPrice.variant1 && matchedVariantPrice.variant2) {
      const variant2Sku = matchedVariantPrice.variant2.sku;
      console.log('[Gallery SKU match] hybridVariant:', variant2Sku);
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) => {
        mediaGallery.setActiveMediaForVariant(variant2Sku, matchedVariantPrice.variant2.featured_image?.product_id);
      });
    }
  }

  setHybridProduct() {
    const comparePriceElm = document.querySelector('#compare-price-button');
    let totalPrice = this.hybridData.price;

    // Check if the hybrid product or main variant is unavailable
    const mainVariantUnavailable = this.options[0].includes('+') && this.variantData[0] && !this.variantData[0].available;
    const hybridProductUnavailable = this.hybridData && !this.hybridData.available;

    if (mainVariantUnavailable || hybridProductUnavailable) {
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    let bundleComparePrice = 0;
    let bundlePrice = 0;
    const bundleData = document.querySelector(`#ProductBundle-${this.dataset.section}`);
    if (bundleData) {
      bundleData.querySelectorAll('input').forEach((checkbox, i) => {
        const inputComparePrice = checkbox.dataset.comparePrice;
        const inputPrice = checkbox.dataset.price;
        if (checkbox.name === 'bundle' && checkbox.checked) {
          const selectedVariant = checkbox.parentElement.nextElementSibling.querySelector('input[type="radio"]:checked');
          bundleComparePrice = extractNumber(selectedVariant.dataset.comparePrice)
          bundlePrice = extractNumber(selectedVariant.dataset.price)
        } else if (checkbox.name === 'bundle-product-single' && checkbox.checked) {
          bundleComparePrice = extractNumber(inputComparePrice)
          bundlePrice = extractNumber(inputPrice)
        }
      });
    }

    if ( this.options[0].includes('+') ) {
      totalPrice = this.variantData[0].price + this.hybridData.price;
      if (comparePriceElm) {
        let compareAtPrice = this.variantData[0].compare_at_price + this.hybridData.price;
        compareAtPrice += bundleComparePrice;
        comparePriceElm.textContent = `$ ${compareAtPrice / 100}`;
        comparePriceElm.classList.remove('hidden')
      };
    } else {
      if (comparePriceElm) {
        if (bundleComparePrice > 0) {
          comparePriceElm.classList.remove('hidden')
        } else {
          comparePriceElm.classList.add('hidden')
        }
        comparePriceElm.textContent = `$ ${((this.hybridData.compare_at_price || this.hybridData.price) + bundleComparePrice) / 100}`
      };
    }

    totalPrice += bundlePrice !== 0 ? bundlePrice : 0;
    const priceString = `$ ${(totalPrice / 100).toFixed(2)}`;

    const productSubmitButton = document.getElementById(`ProductSubmitButton-${this.dataset.section}`);
    productSubmitButton.querySelector('#price-button').textContent = priceString;

    // Scroll gallery to hybrid SKU match (e.g. "SKU1_SKU2")
    if (this.options[0].includes('+') && this.variantData[0] && this.hybridData) {
      const hybridSku = `${this.variantData[0].sku}_${this.hybridData.sku}`;
      console.log('[Gallery SKU match] hybridProduct:', hybridSku);
      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
      mediaGalleries.forEach((mediaGallery) => {
        mediaGallery.setActiveMediaForVariant(hybridSku, this.variantData[0].featured_image?.product_id);
      });
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value')) || this.dataset.hybridVariant === 'true') {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    if (!fieldsets || fieldsets.length === 0) {
      console.error('No fieldsets found.');
      return;
    }

    this.options = fieldsets.map(fieldset => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked);

      if (!checkedRadio) {
        console.error('No radio button is checked in fieldset.');
        return null;
      }

      return checkedRadio.value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            document.querySelectorAll('ul.cart-recommended-products li.cart-recommended-product').forEach(function(selectElement) {
              selectElement.addEventListener('change', function(event) {
                var selectedOption = event.target.value;
                var parentElement = event.target.closest('li.cart-recommended-product');

                parentElement.querySelectorAll('img.additional-image').forEach(function(imageElement) {
                  imageElement.style.display = 'none';
                });

                parentElement.querySelector(`.additional-image.image-${selectedOption}`).style.display = 'block';
              });
            });
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class ProductStyles extends HTMLElement {
  constructor() {
    super();
    this.activeStyle = null;
    this.addEventListener('change', this.onLinkClick);
  }

  onLinkClick(e) {
    e.stopPropagation();

    this.updateStyle();
    this.updateMasterId();

    if (!this.currentStyle) {
      console.log('no current style')
    } else {
      this.updateURL();
      this.renderProductInfo(e);
    }
  }

  updateStyle() {
    const fieldset = this.getElementsByTagName('fieldset')[0];
    this.selectStyle = parseInt(Array.from(fieldset.querySelectorAll('input[name="styles-in"]')).find((radio) => radio.checked).value);
  }

  updateMasterId() {
    this.currentStyle = this.getStyleData().stylesData.find(product => this.selectStyle === product.id);
  }

  updateURL() {
    if (!this.currentStyle || this.dataset.updateUrl === 'false') return;
    window.history.pushState({}, '', `${this.currentStyle.handle}`);
  }

  renderProductInfo(e) {
    const inputs = this.querySelectorAll('input[name="styles-in"]');

    // Iterate through each input element
    inputs.forEach(input => {
      if (input !== e.target) {
        input.checked = false;
        input.removeAttribute('checked');
      }
    });

    const requestedStyleId = this.selectStyle;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const currentStyle = this.currentStyle;

    fetch(this.currentStyle.handle)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentStyle.id !== requestedStyleId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Update page title
        const newTitle = html.querySelector('title');
        if (newTitle) {
          document.title = newTitle.textContent;
        }

        // Update meta description
        const newMetaDescription = html.querySelector('meta[name="description"]');
        const currentMetaDescription = document.querySelector('meta[name="description"]');
        if (newMetaDescription && currentMetaDescription) {
          currentMetaDescription.setAttribute('content', newMetaDescription.getAttribute('content'));
        }

        // Update Open Graph meta tags
        const ogTags = ['og:title', 'og:description', 'og:url', 'og:image'];
        ogTags.forEach(tag => {
          const newOgTag = html.querySelector(`meta[property="${tag}"]`);
          const currentOgTag = document.querySelector(`meta[property="${tag}"]`);
          if (newOgTag && currentOgTag) {
            currentOgTag.setAttribute('content', newOgTag.getAttribute('content'));
          }
        });

        // Update Twitter meta tags
        const twitterTags = ['twitter:title', 'twitter:description', 'twitter:image'];
        twitterTags.forEach(tag => {
          const newTwitterTag = html.querySelector(`meta[name="${tag}"]`);
          const currentTwitterTag = document.querySelector(`meta[name="${tag}"]`);
          if (newTwitterTag && currentTwitterTag) {
            currentTwitterTag.setAttribute('content', newTwitterTag.getAttribute('content'));
          }
        });

        const destination = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const source = html.getElementById(
          `ProductInfo-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          const script = destination.querySelectorAll('script:not([type="application/json"])');
          script.forEach((script) => {
            const scriptContent = script.textContent || script.innerText;
            if (scriptContent.trim()) {
              try {
                eval(scriptContent);

                const onAjaxUpdateExists = /onAjaxUpdate\s*=/.test(scriptContent);
                let onAjaxUpdateFn = null;

                if (onAjaxUpdateExists) {
                  onAjaxUpdateFn = new Function(`
                    ${scriptContent}
                    return onAjaxUpdate;
                  `)();
                }

                if (typeof onAjaxUpdateFn === 'function') {
                  onAjaxUpdateFn();
                }
              } catch (error) {
                console.error('Error executing script:', error);
              }
            }
          });
        }
        const destinationMedia = document.getElementById(`MediaGallery-${this.dataset.section}`);
        const sourceMedia = html.getElementById(
          `MediaGallery-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        if (sourceMedia && destinationMedia) {
          destinationMedia.outerHTML = sourceMedia.outerHTML;
        }

        const destinationKeyFeatures = document.querySelector('[id^="ProductKeyFeatures-"]');
        const sourceKeyFeatures = html.querySelector('[id^="ProductKeyFeatures-"]');
        if ( sourceKeyFeatures )
          destinationKeyFeatures.outerHTML = sourceKeyFeatures.outerHTML

        const destinationProductDetails = document.querySelector('[id^="ProductDetails-"]');
        const sourceProductDetails = html.querySelector('[id^="ProductDetails-"]');
        const scriptProductDetails = destinationProductDetails.nextElementSibling;
        if (sourceProductDetails && destinationProductDetails) {
          destinationProductDetails.outerHTML = sourceProductDetails.outerHTML;

          const scriptContent = scriptProductDetails.textContent || scriptProductDetails.innerText;
          if (scriptContent.trim()) {
            try {
              eval(scriptContent);
            } catch (error) {
              console.error('Error executing script:', error);
            }
          }
        }

        const destinationTestimonials = document.querySelector('[id^="ProductTestimonials-"]');
        const sourceTestimonials = html.querySelector('[id^="ProductTestimonials-"]');
        if ( sourceTestimonials ) {
          destinationTestimonials.outerHTML = sourceTestimonials.outerHTML
          var elem = document.querySelector('.testimonial-slider');
          if (elem) {
            new Flickity( elem, {
              cellAlign: 'left',
              contain: true,
              autoPlay: 3000,
              wrapAround: true
            });
          }
        }

        const destinationAccordion = document.querySelectorAll('[id^="AccordionSlider-"]');
        const sourceAccordion = html.querySelectorAll('[id^="AccordionSlider-"]');
        destinationAccordion.forEach((accordion, i) => {
          if (sourceAccordion && accordion) {
            if (accordion.getAttribute('id') === sourceAccordion[i].getAttribute('id')) {
              accordion.outerHTML = sourceAccordion[i].outerHTML;

              const scripts = accordion.querySelectorAll('script')
              scripts.forEach(script => {
                const scriptContent = script.textContent || script.innerText;
                if (scriptContent.trim()) {
                  try {
                    eval(scriptContent);
                  } catch (error) {
                    console.error('Error executing script:', error);
                  }
                }
              });
            }
          }
        })

        const destinationRecommendedEngine = document.querySelectorAll('.newton-recommend-engine');
        const sourceRecommendedEngine = html.querySelectorAll('.newton-recommend-engine');
        destinationRecommendedEngine.forEach((recommend, i) => {
          if (sourceRecommendedEngine && recommend) {
            if (recommend.getAttribute('id') === sourceRecommendedEngine[i].getAttribute('id')) {
              recommend.outerHTML = sourceRecommendedEngine[i].outerHTML;

              const script = recommend.querySelector('script')
              const scriptContent = script.textContent || script.innerText;
              if (scriptContent.trim()) {
                try {
                  eval(scriptContent); // Execute the JavaScripts
                } catch (error) {
                  console.error('Error executing script:', error);
                }
              }
            }
          }
        })

        const destinationProductModal = document.querySelector('[id^="ProductModal-"]');
        const sourceProductModal = html.querySelector('[id^="ProductModal-"]');
        if ( sourceProductModal ) {
          destinationProductModal.outerHTML = sourceProductModal.outerHTML
        }

        const destinationAttentiveClaimOffer = document.getElementById('attentive-claim-offer');
        const sourceAttentiveClaimOffer = html.getElementById('attentive-claim-offer');
        if ( sourceAttentiveClaimOffer ) {
          destinationAttentiveClaimOffer.outerHTML = sourceAttentiveClaimOffer.outerHTML

          const script = destinationAttentiveClaimOffer.querySelector('script')
          const scriptContent = script.textContent || script.innerText;
          if (scriptContent.trim()) {
            try {
              eval(scriptContent); // Execute the JavaScripts
            } catch (error) {
              console.error('Error executing script:', error);
            }
          }
        }

        // const skuSource = html.getElementById(
        //   `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        // const inventorySource = html.getElementById(
        //   `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );
        // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // const volumePricingSource = html.getElementById(
        //   `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        // );

        // const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        // const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        // const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        // const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        // const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        // if (volumeNote) volumeNote.classList.remove('hidden');
        // if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        // if (qtyRules) qtyRules.classList.remove('hidden');

        // if (source && destination) destination.innerHTML = source.innerHTML;
        // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        // if (skuSource && skuDestination) {
        //   skuDestination.innerHTML = skuSource.innerHTML;
        //   skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        // }

        // if (volumePricingSource && volumePricingDestination) {
        //   volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        // }

        // if (pricePerItemSource && pricePerItemDestination) {
        //   pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
        //   pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        // }

        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('hidden');

        // if (inventoryDestination)
        //   inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        // const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        // this.toggleAddButton(
        //   addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
        //   window.variantStrings.soldOut
        // );

        publish(PUB_SUB_EVENTS.styleChange, {
          data: {
            sectionId,
            html,
            style: currentStyle,
          },
        });
      });
  }

  getStyleData() {
    this.stylesData = this.stylesData || JSON.parse(this.querySelector('#productStyles').textContent);
    this.styleIds = this.stylesData.map(product => product.id)
    return {
      stylesData: this.stylesData,
      styleIds: this.styleIds
    };
  }
}

customElements.define('product-styles', ProductStyles);

// Define the custom dialog component
class DialogPopup extends HTMLElement {
  constructor() {
    super();
    this.openedBy = null;

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handlePointerUp = this.handlePointerUp.bind(this);
    this.hide = this.hide.bind(this);

    // Attach event listeners
    // this.addEventListener('keyup', this.handleKeyUp);
    this.addEventListener('pointerup', this.handlePointerUp);
    this.querySelector('[id^="PopupClose-"]').addEventListener('click', this.hide);
  }

  connectedCallback() {
    // Get the ID of the trigger element
    const triggerId = this.dataset.trigger;
    const triggerElement = document.querySelectorAll(`[data-popup="${triggerId}"]`);

    if (triggerElement) {
      triggerElement.forEach(element => {
        element.addEventListener('click', () => {
          this.show(element);
        });
      });
    } else {
      console.error('Trigger element not found.');
    }
  }

  handleKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.hide();
    }
  }

  handlePointerUp(event) {
    if (event.pointerType === 'mouse' && !event.target.closest('.dialog-content-wrapper')) {
      this.hide();
    }
  }

  triggerShow(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    trapFocus(this, this.querySelector('[role="dialog"]'));
    document.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  show(opener) {
    if (this.dataset.trigger === 'cart-popup') {
      const cartPopup = localStorage.getItem('cartPopup');
      if (!cartPopup) {
        this.triggerShow(opener);
        localStorage.setItem('cartPopup', 'true');
      }
    } else {
      this.triggerShow(opener);
    }
  }

  hide() {
    const iframe = this.querySelector('iframe');
    if (iframe) {
        iframe.remove();
    }

    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}

// Define the custom element
customElements.define('dialog-popup', DialogPopup);

// Define the custom variant hover wrapper element
class CardVariantWrapper extends HTMLElement {
  connectedCallback() {
    // Align the floated swatches to the bottom edge of the media. When placed inline
    // (below image / below price), the wrapper lives inside `.card-wrapper`, so measure
    // against that positioning context; otherwise it is a sibling of the card and its
    // containing block is the grid item (parentNode). Guard against a missing media node.
    const offsetParent = this.closest('.card-wrapper') || this.parentNode;
    const media = offsetParent && offsetParent.querySelector('.card__inner');
    if (!offsetParent || !media) return;

    this.style.bottom = `${(offsetParent.clientHeight - media.clientHeight) + 16}px`;
  }
}
customElements.define('card-variant-wrapper', CardVariantWrapper);

// Define the custom variant hover element
class VariantHoverImage extends HTMLElement {
  constructor() {
    super();
    this.handleHover = this.handleHover.bind(this);

    this.sku = this.dataset.sku;
    this.id = this.dataset.id;
    this.card = this.closest('.grid__item');
    this.cardMedia = this.card.querySelector('.card__media');
  }

  connectedCallback() {
    this.addEventListener('mouseover', this.handleHover);
  }

  handleHover() {
    const primaryImage = this.cardMedia.querySelector('.card-media__image');
    const mainImage = this.cardMedia.querySelector(`.variant-image-${this.id}`);

    if (mainImage) {
      primaryImage.classList.add('fade-out');
      this.cardMedia.querySelectorAll('.variant__media').forEach(media => {
        media.classList.add('fade-out');
      });

      mainImage.classList.remove('hidden');
      mainImage.classList.remove('fade-out');
      mainImage.classList.add('fade-in');
    }
  }
}

customElements.define('variant-hover-image', VariantHoverImage);

// Hero Slider with flickity custom element
class HeroSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const elem = this;
    new Flickity( elem, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: true,
      prevNextButtons: true,
      autoPlay: 3000  // 3 seconds,
    });
  }
}

customElements.define('hero-slider', HeroSlider);

class NewtonSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this;
    this.options = this.dataset;
  }

  setOptions() {
    const options = {};

    for (const key in this.options) {
      if (this.options.hasOwnProperty(key)) {
        const value = this.options[key];
        if (value === '' || value === 'false') {
          options[key] = false;
        } else {
          options[key] = this.options[key] === 'true' ? true : value.toString();
        }
      }
    }

    return options;
  }

  connectedCallback() {
    new Flickity( this.slider, this.setOptions());
  }


  disconnectedCallback() {
    this.slider.flickity.destroy();
  }
}

customElements.define('newton-slider', NewtonSlider);

// Tab Component
class TabComponent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupTabs();
    this.setupContent();
    this.attachEventListeners();
  }

  setupTabs() {
    const tabs = this.querySelectorAll('.tab');
    tabs.forEach((tab, index) => {
      if (index === 1) tab.classList.add('active');
    });
  }

  setupContent() {
    const contents = this.querySelectorAll('.inner-content');
    contents.forEach((content, index) => {
      if (index === 1) content.classList.add('active-content');
      else content.style.display = 'none';
    });
  }

  attachEventListeners() {
    const tabs = this.querySelectorAll('.tab');
    const contents = this.querySelectorAll('.inner-content');
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.switchTab(index);
      });
    });
  }

  switchTab(index) {
    const tabs = this.querySelectorAll('.tab');
    const contents = this.querySelectorAll('.inner-content');

    tabs.forEach((tab, i) => {
      if (i === index) tab.classList.add('active');
      else tab.classList.remove('active');
    });

    contents.forEach((content, i) => {
      if (i === index) {
        content.classList.add('active-content');
        content.style.display = 'block';
      } else {
        content.classList.remove('active-content');
        content.style.display = 'none';
      }
    });
  }
}

customElements.define('tab-component', TabComponent);

// OOS form
// OOSForm wraps the "currently unavailable" notice. The back-in-stock signup
// itself is now handled automatically by Klaviyo's Shopify integration, which
// replaces the add-to-cart button on out-of-stock variants.
class OOSForm extends HTMLElement {
  connectedCallback() {
    // Force-show flag for QA testing: append ?show_oos=1 to any PDP URL
    const params = new URLSearchParams(window.location.search);
    if (params.get('show_oos') === '1') {
      this.classList.remove('oos-notices--hidden');
    }
  }
}
customElements.define('oos-form', OOSForm);

// Key Features Media Carousal
class KeyFeaturesMediaControls extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Get all control items
    const controlItems = this.querySelectorAll('[control-item]');
    const sectionId = this.dataset.sectionId;

    // Add click handler to each control item
    controlItems.forEach(item => {
      item.addEventListener('click', () => {
        // Get the control item string
        const controlItem = item.getAttribute('control-item');
        if (!controlItem) return;

        // Get the media gallery
        const gallery = document.querySelector('[id^="MediaGallery-"]');

        if (gallery) {
          // Find the media element where data-media-sku contains the control-item string (case-insensitive)
          const controlItemLower = controlItem.toLowerCase();
          const mediaElements = gallery.querySelectorAll('[data-media-sku]');
          const mediaElement = Array.from(mediaElements).find(el => {
            const sku = el.getAttribute('data-media-sku');
            return sku && sku.toLowerCase().includes(controlItemLower);
          });

          if (mediaElement && gallery.setActiveMedia) {
            // Remove the active class from all control items
            controlItems.forEach(control => {
              control.classList.remove('border-green-light');
              control.classList.add('border-gray-light');
            });
            // Add the active class to the clicked control item
            item.classList.remove('border-gray-light');
            item.classList.add('border-green-light');
            // Get the media element's ID and call setActiveMedia
            const mediaId = mediaElement.getAttribute('id').split('-').pop();
            gallery.setActiveMedia(`${sectionId}-${mediaId}`, false);
          }
        }
      });
    });
  }

  setActive() {

  }
}
customElements.define('key-features-media-controls', KeyFeaturesMediaControls);

document.addEventListener('DOMContentLoaded', function() {
  const hash = window.location.hash;
  if (hash) {
    const title = hash.substring(1).replace(/-/g, ' ');
    const popupElement = document.querySelector(`[title="${title}"]`);

    if (popupElement) {
      popupElement.click();
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const ctaButtons = document.querySelectorAll('.cta-buttons.filters-enabled a');

  ctaButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const buttonUrl = new URL(button.href);
      const params = new URLSearchParams(buttonUrl.search);

      const url = new URL(window.location.href);
      url.search = '';
      params.forEach((value, key) => {
        if (url.searchParams.has(key)) {
          url.searchParams.append(key, value);
        } else {
          url.searchParams.set(key, value);
        }
      });

      window.history.pushState({}, '', url);

      // Scroll immediately on click
      const productGrid = document.querySelector('.product-grid-container');
      const scrollTarget = productGrid.getBoundingClientRect().top + window.scrollY - headerHeight - 180;
      window.scrollTo({
        top: scrollTarget,
        behavior: 'smooth'
      });

      // Fetch new products and update the product grid container
      fetch(url)
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newFilters = doc.querySelector('#main-collection-filters');
          document.querySelector('#main-collection-filters').innerHTML = newFilters.innerHTML;
          const newProducts = doc.querySelector('.product-grid-container');
          document.querySelector('.product-grid-container').innerHTML = newProducts.innerHTML;
        })
        .catch(error => console.error('Error fetching new products:', error));
    });
  });
});


// TODO: Command/Control + K search feature
// document.addEventListener('keydown', function(event) {
//   // Check if Control (or Command on Mac) and K keys are pressed simultaneously
//   if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
//       event.preventDefault();
//       console.log('Control + K was pressed')
//       // document.getElementById('searchInput').focus(); // Focus on the search input field
//   }
// });

// function initializeBreadPayments() {
//   loadScript('https://connect.breadpayments.com/sdk.js')
//     .then(() => {
//       var placements = [
//         {
//           allowCheckout: false,
//           domID: 'bread-placement-1',
//         },
//         {
//           allowCheckout: false,
//           domID: 'bread-placement-2',
//         },
//       ];
//       BreadPayments.setup({
//         integrationKey: '00a2b68a-401b-4b38-91b8-7cb27afd74ad',
//       });
//       BreadPayments.registerPlacements(placements);
//       BreadPayments.on('INSTALLMENT:APPLICATION_CHECKOUT', () => {});
//       BreadPayments.on('INSTALLMENT:APPLICATION_DECISIONED', () => {});
//       BreadPayments.on('INSTALLMENT:INITIALIZED', () => {
//         alert('Installment Initialized');
//       });
//     })
//     .catch((error) => {
//       console.error('Error loading BreadPayments SDK:', error);
//     });
// }

// if (document.getElementById('bread-placement-1') || document.getElementById('bread-placement-2') || document.querySelectorAll('.bread-placement').length > 0) {
//   // get the initial selector
//   initializeBreadPayments();
// }

// if (!customElements.get('recipient-form')) {
//   customElements.define(
//     'recipient-form',
//     class RecipientForm extends HTMLElement {
//       constructor() {
//         super();
//         this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
//         this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
//         this.checkboxInput.disabled = false;
//         this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
//         this.hiddenControlField.disabled = true;
//         this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
//         this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
//         this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
//         this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
//         this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
//         if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

//         this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
//         this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
//         this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
//         this.defaultErrorHeader = this.errorMessage?.innerText;
//         this.currentProductVariantId = this.dataset.productVariantId;
//         this.addEventListener('change', this.onChange.bind(this));
//         this.onChange();
//       }

//       cartUpdateUnsubscriber = undefined;
//       variantChangeUnsubscriber = undefined;
//       cartErrorUnsubscriber = undefined;

//       connectedCallback() {
//         this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
//           if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
//             this.resetRecipientForm();
//           }
//         });

//         this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
//           if (event.data.sectionId === this.dataset.sectionId) {
//             this.currentProductVariantId = event.data.variant.id.toString();
//           }
//         });

//         this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
//           console.log(event, event.productVariantId)
//           if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
//             this.displayErrorMessage(event.message, event.errors);
//           }
//         });
//       }

//       disconnectedCallback() {
//         if (this.cartUpdateUnsubscriber) {
//           this.cartUpdateUnsubscriber();
//         }

//         if (this.variantChangeUnsubscriber) {
//           this.variantChangeUnsubscriber();
//         }

//         if (this.cartErrorUnsubscriber) {
//           this.cartErrorUnsubscriber();
//         }
//       }

//       onChange() {
//         if (this.checkboxInput.checked) {
//           this.enableInputFields();
//           this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
//         } else {
//           this.clearInputFields();
//           this.disableInputFields();
//           this.clearErrorMessage();
//           this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
//         }
//       }

//       inputFields() {
//         return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
//       }

//       disableableFields() {
//         return [...this.inputFields(), this.offsetProperty];
//       }

//       clearInputFields() {
//         this.inputFields().forEach((field) => (field.value = ''));
//       }

//       enableInputFields() {
//         this.disableableFields().forEach((field) => (field.disabled = false));
//       }

//       disableInputFields() {
//         this.disableableFields().forEach((field) => (field.disabled = true));
//       }

//       displayErrorMessage(title, body) {
//         this.clearErrorMessage();
//         this.errorMessageWrapper.hidden = false;
//         if (typeof body === 'object') {
//           this.errorMessage.innerText = this.defaultErrorHeader;
//           return Object.entries(body).forEach(([key, value]) => {
//             const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
//             const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
//             const message = `${value.join(', ')}`;
//             const errorMessageElement = this.querySelector(`#${errorMessageId}`);
//             const errorTextElement = errorMessageElement?.querySelector('.error-message');
//             if (!errorTextElement) return;

//             if (this.errorMessageList) {
//               this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
//             }

//             errorTextElement.innerText = `${message}.`;
//             errorMessageElement.classList.remove('hidden');

//             const inputElement = this[`${key}Input`];
//             if (!inputElement) return;

//             inputElement.setAttribute('aria-invalid', true);
//             inputElement.setAttribute('aria-describedby', errorMessageId);
//           });
//         }

//         this.errorMessage.innerText = body;
//       }

//       createErrorListItem(target, message) {
//         const li = document.createElement('li');
//         const a = document.createElement('a');
//         a.setAttribute('href', target);
//         a.innerText = message;
//         li.appendChild(a);
//         li.className = 'error-message';
//         return li;
//       }

//       clearErrorMessage() {
//         this.errorMessageWrapper.hidden = true;

//         if (this.errorMessageList) this.errorMessageList.innerHTML = '';

//         this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
//           field.classList.add('hidden');
//           const textField = field.querySelector('.error-message');
//           if (textField) textField.innerText = '';
//         });

//         [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
//           inputElement.setAttribute('aria-invalid', false);
//           inputElement.removeAttribute('aria-describedby');
//         });
//       }

//       resetRecipientForm() {
//         if (this.checkboxInput.checked) {
//           this.checkboxInput.checked = false;
//           this.clearInputFields();
//           this.clearErrorMessage();
//         }
//       }
//     }
//   );
// }
